import { Colour } from "../../redux/slices/colorsSlice";
import hexToRgb from "../convertions/HexToRgb";
import rgbToHsl from "../convertions/RgbToHsl";

export const colourToColourObjectType = (
  hex: string,
  name: string | null = null,
  category: string | null = null,
  associateColours: Colour[] | [] = []
) => {
  return {
    name,
    value: {
      hex: hex,
      rgb: hexToRgb(hex),
      hsl: rgbToHsl(hexToRgb(hex)),
    },
    category: category ? category : name,
    associateColours: associateColours,
  };
};
